import * as React from 'react'
import styles from './styles.module.scss'
import { User, UserDetailsPanel } from './user-panel/UserDetailsPanel'
import { ContactUs } from './contact-us/ContactUs'
import { Notifications, NotificationProps } from './notifications/Notifications'
import { Notification } from './notifications/notification-utils'
import { UserSupportPanel } from './user-support/UserSupportPanel'
import classNames from 'classnames'
import { MenuOutlined } from '@ant-design/icons'
import {useMemo} from "react";
import VantageTitle from "./vantage-title/VantageTitle";

export interface Resource {
  code: string
  label: string
  children: Resource[]
}

export type SupportBarProps = {
  user?: User,
  resources: Resource[],
  notifications?: Notification[]
  markNotificationsRead: NotificationProps['markNotificationsRead']
  transparent?: boolean
  onClickMenu?: () => void
}

const Menu = ({ onClickMenu }: Pick<SupportBarProps, 'onClickMenu'>) => {
  if (onClickMenu === undefined) {
    return null
  }

  return (
    <div className={styles['support-bar-menu']} onClick={onClickMenu}>
      <MenuOutlined />
    </div>
  )
}

export const SupportBar = ({
  user,
  resources,
  notifications,
  markNotificationsRead,
  transparent,
  onClickMenu
}: SupportBarProps) => {

  const [hasUserSupportPanel, hasNotifications, hasContactUs] = useMemo(
    () => {
      const navbarResources = resources.find(resouce => resouce.code === "NAVBAR");
      if (navbarResources === undefined) {
        return [false, false, false, false];
      };
      return [
        !!navbarResources.children.find(resource => resource.code === "NAVBAR_SUPPORT"),
        !!navbarResources.children.find(resource => resource.code === "NAVBAR_NOTIFICATIONS"),
        !!navbarResources.children.find(resource => resource.code === "NAVBAR_CONTACT_US"),
      ]
    },
    [resources]);

  return (
    <React.Fragment>
      <div
        className={classNames(styles.supportBar, {
          [styles.transparentMode]: transparent === true
        })}
      >
        <Menu onClickMenu={onClickMenu} />
        <div className={styles['support-bar-content']}>
          <VantageTitle clickable={true}/>
          <div className={styles.actionsWrapper}>
            {hasUserSupportPanel && <UserSupportPanel />}
            {hasNotifications && <Notifications
              markNotificationsRead={markNotificationsRead}
              notifications={notifications}
            />}
            {hasContactUs && <ContactUs/>}
            <UserDetailsPanel user={user} />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
